<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="search"
      height="calc(100vh - 275px)"
      class="font-resp-tabela"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title class="ml-n3">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Cadastro de Sistemas de Integração
          </v-toolbar-title>

          <v-divider class="mx-5" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            class="mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            style="max-width: 450px;"
          ></v-text-field>
          <v-btn color="primary" dark @click="dialog = true">Novo</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon
          title="Editar Sistema de Integração"
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon title="Remover Sistema de Integração" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-btn
            color="#000"
            icon
            style="margin-left: -10px"
            @click="fecharDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="headline ml-4 mb">{{ formTitle }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-8">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.descricao"
                label="Descrição*"
                height="10"
                outlined
                chips
                :error-messages="descricaoErrors"
                @input="$v.editedItem.descricao.$touch()"
                @blur="$v.editedItem.descricao.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.sigla"
                label="Sigla*"
                height="10"
                outlined
                chips
                :error-messages="siglaErrors"
                @keypress="errors.sigla.jaCadastrada = false"
                @input="$v.editedItem.sigla.$touch()"
                @blur="$v.editedItem.sigla.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions class="mt-n3">
          <v-spacer></v-spacer>
          <v-btn text @click="fecharDialog()">Sair</v-btn>
          <v-btn color="blue darken-1" text @click="save()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfigApi from "./../../api/cfg";
import { required } from "vuelidate/lib/validators";
export default {
  data: () => ({
    search: "",
    dialog: false,

    editedIndex: -1,
    editedItem: {
      id: "",
      sigla: "",
      descricao: "",
    },

    headers: [
      { text: "Código", value: "id" },
      { text: "Descrição", value: "descricao" },
      { text: "Sigla", value: "sigla" },
      { text: "Ações", value: "action", align: "right", sortable: false },
    ],
    desserts: [],

    errors: {
      sigla: {
        jaCadastrada: false,
      },
    },
  }),

  validations: {
    editedItem: {
      sigla: {
        required,
        jaCadastrada() {
          if (this.errors.sigla.jaCadastrada) {
            return false;
          } else {
            return true;
          }
        },
      },
      descricao: {
        required,
      },
    },
  },

  created() {
    this.buscarSistemasIntegracao();
  },

  computed: {
    siglaErrors() {
      const errors = [];
      if (!this.$v.editedItem.sigla.$dirty) return errors;
      !this.$v.editedItem.sigla.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.sigla.jaCadastrada &&
        errors.push("Sigla única já cadastrada, informe uma diferente.");
      return errors;
    },
    descricaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.descricao.$dirty) return errors;
      !this.$v.editedItem.descricao.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Novo Sistema de Integração"
        : "Editar Sistema de Integração";
    },
  },

  methods: {
    buscarSistemasIntegracao() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        ConfigApi.getSistemasIntegracao(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts = response.data.sistemas;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          id: this.editedItem.id,
          sigla: this.editedItem.sigla,
          descricao: this.editedItem.descricao,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          ConfigApi.addSistemasIntegracao(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (!response.data.existe) {
                this.fecharDialog();
                this.buscarSistemasIntegracao();
              } else {
                this.errors.sigla.jaCadastrada = true;
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    deleteItem(item) {
      if (confirm("Deseja Realmente Excluir este Item")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          id: item.id,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          ConfigApi.deleteSistemasIntegracao(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.buscarSistemasIntegracao();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    fecharDialog() {
      this.dialog = false;
      this.editedItem = {};
      this.$v.$reset();
    },
  },
};
</script>

<style>
</style>
